const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");

export function trackEvent(name: string, properties?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;

  const payload = {
    name,
    pageUrl: window.location.pathname + window.location.search,
    properties: properties ?? null,
  };

  try {
    const url = `${BASE}/api/events`;
    const body = JSON.stringify(payload);

    if (typeof navigator !== "undefined" && typeof navigator.sendBeacon === "function") {
      const blob = new Blob([body], { type: "application/json" });
      if (navigator.sendBeacon(url, blob)) return;
    }

    void fetch(url, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {
      /* swallow — analytics must never break the app */
    });
  } catch {
    /* swallow */
  }
}
